import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

import { ToasterService } from '../../services/toaster.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { AppService } from '../../../app.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';

@Component({
  selector: 'gtapp-configure-scan-menu',
  standalone: false,
  templateUrl: './configure-scan-menu.component.html',
  styleUrl: './configure-scan-menu.component.scss',
})
export class ConfigureScanMenuComponent implements OnInit, OnDestroy {
  scanPreferences: any = {};
  scanPreferencesBackup: any = {};

  constructor(
    @Optional() @Inject(DIALOG_DATA) public dialogData: any,
    @Optional() protected dialgoRef: DialogRef,
    private profileService: UserProfileService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private appService: AppService,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    let userData = this.appService.getUserData();
    const scanMenuConfig = userData?.preferences?.scan_menu_config || {};

    if (Object.keys(scanMenuConfig)?.length) {
      this.scanPreferences = { ...scanMenuConfig };
    } else {
      // default check to mark true for all items
      this.scanPreferences = {
        scan_gps: true,
        scan_qr: true,
        scan_nfc: true,
      };
    }
    this.scanPreferencesBackup = JSON.parse(
      JSON.stringify(this.scanPreferences),
    );
  }
  updatePreferences() {
    this.spinnerService.hide();
    this.profileService
      .updateUser(
        {
          data: {
            scan_menu_config: this.scanPreferences,
          },
        },
        { save_preference: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          let userData = this.appService.getUserData();
          if (userData?.preferences) {
            userData.preferences.scan_menu_config = this.scanPreferences;
            this.appService.setUserData(userData);
          }
          this.toasterService.setMessage({
            successMessage: 'Preferences Updated',
            errorMessage: '',
          });
          this.onCloseDialog();
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onCloseDialog(value: any = false) {
    this.dialgoRef.close(value);
  }
}
